export default __webpack_public_path__ + "static/media/4742.ed050c66.png";